// 企业用户信息
export default {
    BN: 'название компании',
    OC: 'Контактная информация организации',
    CI: 'Контактная информация',
    AM: 'Модуль авторизации',
    AV: 'Авторизованная версия',
    PN: 'Название предмета',
    IPW: 'Белый список IP-адресов',
    AAK: 'Добавить AK',
    EIPW: 'Изменить белый список IP-адресов',
    tip_IP: 'Неправильный формат IP, см. Описание ниже',
    tip_PN: 'Пожалуйста, введите название проекта',
    tip_OSITI: '只有IP白名单内的服务器才能成功发起调用',
    tip_Format: 'формат: 202.198.16.3,202.198.0.0/16 Введите IP-адрес или IP-префикс сегмента сети, разделенные английскими запятыми половинной ширины. Если вы не хотите налагать какие-либо ограничения на IP-адрес, установите его как 0.0.0.0/0',
    tip_UIWC: '(Используйте с осторожностью. Если AK утекнет квоту, он будет использован его пользователями. Его можно использовать в качестве DEBUG перед подключением к сети. Установите разумный белый список IP-адресов для официального AK в сети)',
}